/* unplugin-vue-components disabled */import { render } from "./checkbox.vue?vue&type=template&id=df3cab1a&scoped=true"
import script from "./checkbox.vue?vue&type=script&lang=js"
export * from "./checkbox.vue?vue&type=script&lang=js"

import "./checkbox.vue?vue&type=style&index=0&id=df3cab1a&lang=stylus&scoped=true"

import exportComponent from "/home/runner/work/buzz-front/buzz-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-df3cab1a"],['__file',"src/controls/checkbox.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "df3cab1a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('df3cab1a', __exports__)) {
    api.reload('df3cab1a', __exports__)
  }
  
  module.hot.accept("./checkbox.vue?vue&type=template&id=df3cab1a&scoped=true", () => {
    api.rerender('df3cab1a', render)
  })

}


export default __exports__